export default "__VITE_ASSET__CPf_zOjB__"